
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 52.125 51.768\" id=\"icon-tie\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M30.351,0c12.352,2.046,21.774,12.773,21.774,25.704c0,14.395-11.669,26.063-26.063,26.063\r\n\tS0,40.099,0,25.704C0,12.773,9.421,2.046,21.775,0c-0.032,0.21-0.066,0.422-0.066,0.641v2.203c0,1.603,0.903,2.99,2.216,3.723\r\n\tl-0.187,0.891L21.44,33.14l4.622,7.547l4.622-7.547L28.372,7.359l-0.167-0.795c1.311-0.735,2.209-2.12,2.209-3.72V0.641\r\n\tC30.414,0.422,30.382,0.21,30.351,0\"/> </symbol>";
module.exports = sprite.add(image, "icon-tie");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/tie.svg
 ** module id = 234
 ** module chunks = 24
 **/